const form = document.querySelector("#zipcodeCheck");
if (form) form.addEventListener("submit", handleSubmit)

async function handleSubmit(e) {
  e.preventDefault();
  const formData = new FormData(e.target);
  const zipcode = formData.get("zipcode");
  if (!zipcode) return;
 
  zipcodeModal("loading")
  const res = await fetch("https://bakker-de-graaf-backend.ubo-dev.nl/check-zipcode?zipcode=" + zipcode)
  const text = await res.text()
  await new Promise(resolve => setTimeout(resolve, 1000)); 

  const isValid = text === "true";
  zipcodeModal(isValid ? "success" : "error");
}


function zipcodeModal(state = "success") {
  const loading = `
    <div class="flex flex-col items-center text-center">
      <svg class="animate-spin h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      <p class="mt-2">We zijn je postcode aan het controleren..</p>
    </div>
  `

  const success = `
    <div class="flex flex-col items-center text-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-ufo-green"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
      
      <strong class="mt-2">Goed nieuws!</strong>
      <p>We bezorgen in jouw postcode!</p>
    </div>
  `

  const error = `
    <div class="flex flex-col items-center text-center">
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-red-600"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>      
      <strong class="mt-2">Jammer</strong>
      <p class="max-w-[400px]">We bezorgen niet in jouw postcode, neem <a class="underline text-turkish-sea" href="/pages/contact/">contact</a> met ons op voor eventuele mogelijkheden.</p>
    </div>
  `

  let component = loading;
  switch (state) {
    case "loading":
      component = loading;
      break;
    case "success":
      component = success;
      break;
    case "error":
      component = error;
      break;
  }

  const html = `
    <div id="zipcodeModal" class="fixed top-0 left-0 w-full h-full z-50 flex items-center justify-center">
      <div data-close-modal class="absolute top-0 left-0 w-full h-full bg-black opacity-30"></div>
      <div class="bg-white rounded-lg shadow-lg p-4 z-10 relative sm:mx-0 mx-4">
          <button type="button" data-close-modal class="absolute top-0 right-0 p-2 rounded-full">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>

          ${component}
      </div>
    </div>
  `


  let modal = document.querySelector("#zipcodeModal")
  if (modal) modal.remove();

  document.body.classList.add("overflow-hidden")
  document.body.insertAdjacentHTML("beforeend", html);

  modal = document.querySelector("#zipcodeModal")
  modal.querySelectorAll("[data-close-modal]").forEach(item => item.addEventListener("click", e => {
    modal.remove();
    document.body.classList.remove("overflow-hidden")
  }))
}